import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { KuxSelfServiceLink } from '../interfaces/self-service';

import { getAssetsByChannelId } from './asset';
import { parseSelfServiceLinks } from './self-service.helper';

/**
 * Get self service links by channelId
 * @param channelId: number - ChannelId
 */
export const getSelfServiceLinks = (channelId: number): Observable<KuxSelfServiceLink[]> => {
  return getAssetsByChannelId({ channelId }).pipe(map(parseSelfServiceLinks));
};
